// extracted by mini-css-extract-plugin
export var addressFields = "_jp-0";
export var animationContainer = "_jp-1";
export var footer = "_jp-2";
export var lineItems = "_jp-3";
export var modalContent = "_jp-4";
export var orderName = "_jp-5";
export var strong = "_jp-6";
export var warning = "_jp-7";